fourToldApp.factory("cryptool", function(){
    
    var encryptData;
    var decryptData;
    var key = '6d090796-ecdf-11ea-adc1-0242ac112345'
    var _encryptData = function (text) {
      
        if(text == null || text.lenght == 0)
            return "";
      
        
    return CryptoJS.AES.encrypt(text, key).toString();

   };

   var _decryptData = function (ciphertext) {
        if(ciphertext == null || ciphertext.lenght == 0)
        return "";
    
    
    const bytes = CryptoJS.AES.decrypt(ciphertext, key);    
    return bytes.toString(CryptoJS.enc.Utf8);

};

   return {
    encryptData: _encryptData,
    decryptData: _decryptData
   }
});


